import { render, staticRenderFns } from "./detail-card.vue?vue&type=template&id=17a2a6be"
import script from "./detail-card.vue?vue&type=script&lang=ts"
export * from "./detail-card.vue?vue&type=script&lang=ts"
import style0 from "./detail-card.vue?vue&type=style&index=0&id=17a2a6be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingSpinner: require('/vercel/path0/components/loading-spinner.vue').default,UiAccordion: require('/vercel/path0/components/ui/accordion.vue').default,ChefBookPersonalInformation: require('/vercel/path0/components/chef/book/personal-information.vue').default,UiButton: require('/vercel/path0/components/ui/button.vue').default,UiError: require('/vercel/path0/components/ui/error.vue').default,UiLink: require('/vercel/path0/components/ui/link.vue').default,UiModal: require('/vercel/path0/components/ui/modal.vue').default,UiIconShield: require('/vercel/path0/components/ui/icon/shield.vue').default,UiIconStarEmpty: require('/vercel/path0/components/ui/icon/star-empty.vue').default,UiIconChat: require('/vercel/path0/components/ui/icon/chat.vue').default,UiOutlineButton: require('/vercel/path0/components/ui/outline-button.vue').default})
